import * as React from 'react';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { LeftAppBarButton } from '@lialo/pwa-ui/lib/PageComponents/AppBar';

interface Props {
  className?: string;
  onClick: () => void;
}

const BackButton = ({ className, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <LeftAppBarButton className={className} ariaLabel={t('actions.back')} icon={<ArrowBack />} onClick={onClick} />
  );
};

export default BackButton;
